import React, { useState } from 'react';
import { Animated, Keyboard, Platform, StyleSheet, View } from 'react-native';
import useShake from 'src/presentation/hooks/useShake';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import FormField from 'src/presentation/components/atoms/FormField';
import SubmitButton from 'src/presentation/components/atoms/SubmitButton';
import Translations from 'src/core/utils/Translations';
import { useAuthenticationStore } from 'src/domain/stores/useAuthenticationStore';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import Dimens from 'src/core/utils/Dimens';
import type { RootStackParamList } from 'src/presentation/navigation/types/NavigationTypes';

function ForgotPasswordForm() {
	const authStore = useAuthenticationStore();
	const { validator } = useServicesStore();
	const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();
	const [email, setEmail] = useState<string>('');
	const [emailError, setEmailError] = useState<string>('');
	const { translateX: buttonShake, shake } = useShake();

	const isIos = Platform.OS === 'ios';

	const onSubmit = async () => {
		Keyboard.dismiss();
		if (!email.trim()) {
			setEmailError(Translations.errorFieldRequired);
			shake();
			return;
		}
		if (!validator.validateEmail({ email })) {
			setEmailError(Translations.errorInvalidEmailInline);
			shake();
			return;
		}
		setEmailError('');
		const success = await authStore.forgotPassword(email);
		if (success) navigation.goBack();
	};

	return (
		<View>
			<FormField
				error={emailError}
				keyboardType="email-address"
				label={Translations.labelEmail}
				placeholder={isIos ? Translations.placeholderEmail : Translations.placeholderEmailShort}
				value={email}
				onChangeText={(text) => {
					setEmail(text);
					if (emailError) setEmailError('');
				}}
			/>
			<Animated.View style={{ transform: [{ translateX: buttonShake }] }}>
				<SubmitButton
					isLoading={isIos ? authStore.isLoading : undefined}
					label={Translations.buttonSubmit}
					style={isIos ? undefined : styles.submit}
					onPress={onSubmit}
				/>
			</Animated.View>
		</View>
	);
}

export default ForgotPasswordForm;

const styles = StyleSheet.create({
	submit: {
		marginTop: Dimens.margin32,
		flexDirection: 'row',
		justifyContent: 'center',
	},
});
